<template>
  <div class="statuses">
            
            <ul>
              <li class="firstStatus sentStatus" :class="{active: printFileSent == 'yes'}" @click="toggleStatus('printFileSent')">
                <i class="fa fa-check" aria-hidden="true" v-if="printFileSent == 'yes'"></i>
                  Sent
                </li>
              <li class="checkedStatus" :class="{active: printFileChecked == 'yes'}" @click="toggleStatus('printFileChecked')" >
                <i class="fa fa-check" aria-hidden="true" v-if="printFileChecked == 'yes'"></i>
                Checked
              </li>
              <li class="lastStatus printedStatus" :class="{active: printFilePrinted == 'yes'}"  @click="toggleStatus('printFilePrinted')">
                <i class="fa fa-check" aria-hidden="true" v-if="printFilePrinted == 'yes'"></i>
                Printed</li>
            </ul>

            
          </div>
</template>

<script>
import ItemListService from '../../services/item-list.service'
import EventBus from '../../EventBus';
  export default {
    props:{
      itemId: {
        type: Number,
        default: null
      },
      printFileSent: {
        type: String,
        default: ''
      },
      printFileChecked: {
        type: String,
        default: ''
      },
      printFilePrinted: {
        type: String,
        default: ''
      }
    },
    methods: {
      async toggleStatus(statusType){
          try{
              let data = {
                value: this[statusType] == 'yes' ? 'no' : 'yes',
                field: statusType
              }
              const result = await ItemListService.setSingleValue(data, this.itemId);


              EventBus.$emit('item-in-list-updated', {id: this.itemId, theItem: result.data.theItem})

              if(data.field == 'printFileSent'){
                 EventBus.$emit('items-list.print-file-sent-added', this.itemId);
              }

          }catch(errors){
            console.log(errors)

            this.$toasted.show(errors.response.data.message, {
              type: "error",
              action: {
                text: "Cancel",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });

          }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .statuses{
        float:right;
        ul{
          list-style-type: none;
          padding-left: 0;
          margin-bottom: 0;
          li{
            display: inline-block;
            padding: 3px 5px;
            font-size: 11px;
            border:1px solid rgb(49, 49, 49);
            color: rgb(49, 49, 49);
            margin-right: 2px;
            text-transform: uppercase;
            cursor: pointer;
          }
          li:first-child{
            border-radius: 3px 0 0 3px;
          }
          li:last-child{
            border-radius: 0 3px 3px 0;
          }
          li.active{
            color: #fff;
          }
          li.active.sentStatus{
             background-color: #12CBC4;
             border-color: #12CBC4;
          }
          li.active.checkedStatus{
             background-color:#F79F1F;
             border-color:#F79F1F;
          }
          li.active.printedStatus{
             background-color:#A3CB38;
             border-color: #A3CB38;
          }
        }
      }
      
</style>